import { render, staticRenderFns } from "./BtnGroup.vue?vue&type=template&id=7b6c3527&scoped=true&"
import script from "./BtnGroup.vue?vue&type=script&lang=js&"
export * from "./BtnGroup.vue?vue&type=script&lang=js&"
import style0 from "./BtnGroup.vue?vue&type=style&index=0&id=7b6c3527&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b6c3527",
  null
  
)

export default component.exports